import React, { useState } from 'react';
import './AddContextModal.css';

interface AddContextModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (context: { name: string; type: string; content: string | File }) => void;
  projectId: string;
}

const AddContextModal: React.FC<AddContextModalProps> = ({ isOpen, onClose, onSubmit, projectId }) => {
  const [contextType, setContextType] = useState('plaintext');
  const [contextName, setContextName] = useState('');
  const [contextContent, setContextContent] = useState('');
  const [contextUrl, setContextUrl] = useState('');
  const [contextFile, setContextFile] = useState<File | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let content: string | File = '';
    
    if (contextType === 'plaintext') {
      content = contextContent;
    } else if (contextType === 'url') {
      content = contextUrl;
    } else if (contextType === 'file') {
      if (!contextFile) {
        alert('Please select a file to upload.');
        return;
      }
      content = contextFile;
    }
    
    // Pass the collected data to the parent component (the "Chef")
    onSubmit({ name: contextName, type: contextType, content });

    // The modal will be closed by the parent component after submission is handled.
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setContextFile(e.target.files[0]);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <form onSubmit={handleSubmit}>
          <h2>Add New Context</h2>
          
          <div className="form-group">
            <label htmlFor="contextName">Context Name</label>
            <input
              id="contextName"
              type="text"
              value={contextName}
              onChange={(e) => setContextName(e.target.value)}
              placeholder="e.g., 'Company Financials Q1'"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contextType">Context Type</label>
            <select id="contextType" value={contextType} onChange={(e) => setContextType(e.target.value)}>
              <option value="plaintext">Plain Text</option>
              <option value="file">File</option>
              <option value="url">URL</option>
            </select>
          </div>

          {contextType === 'plaintext' && (
            <div className="form-group">
              <label htmlFor="contextContent">Text Content</label>
              <textarea
                id="contextContent"
                value={contextContent}
                onChange={(e) => setContextContent(e.target.value)}
                rows={10}
                placeholder="Paste your text content here..."
                required
              />
            </div>
          )}

          {contextType === 'url' && (
            <div className="form-group">
              <label htmlFor="contextUrl">URL</label>
              <input
                id="contextUrl"
                type="url"
                value={contextUrl}
                onChange={(e) => setContextUrl(e.target.value)}
                placeholder="https://example.com/source"
                required
              />
            </div>
          )}

          {contextType === 'file' && (
            <div className="form-group">
              <label htmlFor="contextFile">File</label>
              <input
                id="contextFile"
                type="file"
                onChange={handleFileChange}
                required
              />
              {contextFile && <p className="file-name">Selected: {contextFile.name}</p>}
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="button-primary">Add Context</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContextModal; 